export const schoolProgramAttendanceHeaders = [
  {
    id: "school_name",
    numeric: false,
    disablePadding: true,
    label: "School"
  },
  {
    id: "day",
    numeric: false,
    disablePadding: true,
    label: "Day"
  },
  {
    id: "program_time",
    numeric: false,
    disablePadding: true,
    label: "Time"
  },
  {
    id: "program_duration",
    numeric: false,
    disablePadding: true,
    label: "Duration"
  },
  {
    id: "course_abbr",
    numeric: false,
    disablePadding: true,
    label: "Course"
  },
  {
    id: "student_id",
    numeric: false,
    disablePadding: true,
    label: "Student ID"
  },
  {
    id: "student_name",
    numeric: false,
    disablePadding: true,
    label: "Student Name"
  },
  {
    id: "parent_name",
    numeric: false,
    disablePadding: true,
    label: "Parent Name"
  },
  {
    id: "phone",
    numeric: false,
    disablePadding: true,
    label: "Phone Number"
  },
  {
    id: "sessions",
    numeric: false,
    disablePadding: true,
    label: "Sessions"
  },
];
